import { render, staticRenderFns } from "./company-item.vue?vue&type=template&id=1c239ffc&scoped=true&"
import script from "./company-item.vue?vue&type=script&lang=js&"
export * from "./company-item.vue?vue&type=script&lang=js&"
import style0 from "./company-item.vue?vue&type=style&index=0&id=1c239ffc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c239ffc",
  null
  
)

export default component.exports